// extracted by mini-css-extract-plugin
export default {"empty":"DefaultPage_empty__37eSY","main":"DefaultPage_main__CWhiE","container":"DefaultPage_container__t7nYm"};